export default {
  namespaced: true,

  state: {
    recovery: undefined
  },

  mutations: {
    set(state, recovery) {
      state.recovery = recovery;
    },

    clearRecord(state) {
      state.recovery = undefined;
    }
  },

  getters: {
    get(state) {
      return state.recovery;
    }
  }
};
